
export default {
  scrollToTop: true,

  async asyncData({ $axios }) {
    const communitys = await $axios.$get('/collection', {
      params: {
        statistics: true,
      },
    })
    return {
      communitys,
    }
  },
  computed: {
    awayLink() {
      switch (this.$route.path) {
        case '/marketplace':
          return '/events'
        case '/marketplace/offers':
          return '/offers'
        case '/marketplace/goods':
          return '/goods'

        default:
          return '/events'
      }
    },
  },
}
